export default "__VITE_ASSET__DxO4Bxs7__"